import React from "react";
import { Link } from "react-router-dom";
import {Path} from '../Path.js';

function Footer() {
  return (
    <>
      {/* <div className="container">
       
            <div className="row">
                <div className="col-sm-6">
                    <img src={'images/logo.png'} />
                    <p className='foot-text'>Lorem Ipsum is simply dummy text of typesetting industry.</p>
                
                </div>
                <div className="col-sm-3">
                    <h3 className='foot-head'>Download</h3>
                        <p>Whitepaper</p>
                </div>
                <div className="col-sm-3">
                    <h3 className='foot-head'>Social</h3>
                        <div className='social'>
                        <img src={'images/logo.png'} />
                        <p className='foot-text'>Facebook</p>
                        </div>
                </div>
            </div>

       
       

       
            <div className="row copyright">
                <div className="col-sm-12 copyright"> ©2022 Little Billionaires | All Rights Reserved</div>
            
            </div>
        </div> */}

      <footer className="mainfooter" role="contentinfo">
        <div className="footer-middle">
          <div className="container footer">
            <div className="row footer">
              <div className="col-sm-6">
                {/* <!--Column1--> */}
                <div className="footer-pad">
                  <Link to={"/"}>
                    <img src={"images/logo.png"} alt="footer-logo" className="foot-logo" />
                  </Link>
                  <p className="foot-text">
                    7,777 unique billionaires who need owners.
                  </p>
                </div>
              </div>
              <div className="col-sm-3 quick_links">
                {/* <!--Column1--> */}
                <div className="footer-pad">
                  <h4>DOWNLOAD</h4>
                  <ul className="list-unstyled">
                    <li>
                      {/* <Link to="/">Whitepaper</Link> */}
                      <a href={Path+"Whitepaper_FINAL_1.1-2.pdf"} rel="noreferrer" target="_blank">Whitepaper</a>
                    </li>
                    {/* <li><Link to="/">Login</Link></li>
            <li><Link to="/">Register</Link></li>
            <li><Link to="/">Dashboard</Link></li>
            <li><Link to="/">Forgot Password</Link></li> */}
                  </ul>
                </div>
              </div>
              <div className="col-sm-3 social_links">
                <h4>Social</h4>
                <ul className="social-network social-circle">
                  <li>
                    <Link to="/">
                      <ul className="social icons_social"  onClick={()=>window.open('https://twitter.com/LittleBillions')}>
                        <li className="foot-social effecthov">
                          <img src={"images/foot-twitter.png"} alt="twitter" />
                        </li>
                        <li className="foot-social">Twitter</li>
                      </ul>
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <ul className="social icons_social" onClick={()=>window.open('https://www.instagram.com/littlebillionaires.io/')}>
                        <li className="foot-social effecthov">
                          <img src={"images/insta-ffot.png"} alt="instagram"/>
                        </li>
                        <li className="foot-social">Instagram</li>
                      </ul>
                    </Link>
                  </li>

                  <li>
                    <Link to="/">
                      <ul className="social icons_social" onClick={()=>window.open('https://discord.gg/7UD5mSxSSW')}>
                        <li className="foot-social effecthov">
                          <img src={"images/discord-foot.png"} alt="discord" style={{marginTop:"-4px"}}/>
                        </li>
                        <li className="foot-social">Discord</li>
                      </ul>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 copy">
                <p className="text-center">
                  &copy; Copyright 2022 - Little Billionaires. All rights
                  reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
